/*
 * Nav Component
 * ---
 *
 * @param props.url {String} - url of Wantable homepage
 * @param props.userIconLoggedOut {String} - url of svg image to be used
 * @param props.searchIcon {String} - url of svg image to be used
 * @param props.cartIcon {String} - url of svg image to be used
 * @param props.logo {String} - url of svg image to be used
 * @param props.logoMobile {String} - url of svg image to be used
 * @param props.optionalCTA {Object} - optional value of cta link
 *
 */

import React, { useEffect, useMemo, useState } from "react";
import { Modal } from "@wantable/Shared/Components";
import LoginForm from "../LoginForm/LoginForm";
import SignUpForm from "../SignUpForm/SignUpForm";
import ForgotPasswordForm from "../ForgotPasswordForm/ForgotPasswordForm";
import { ModalType}  from "../types";
import DesktopNav from "./DesktopNav";
import MobileNav from "./MobileNav";
import { useScreenSize } from "@wantable/Shared"

export interface NavProps {
  isLoggedIn: boolean;
  cartItemsAmount: number;
  wishlistItemsAmount: number;
  openedModal: ModalType;
  onAfterLogin?: () => void;
  onLogout: () => void;
  openModal: () => void;
}

const Nav = (props: NavProps) => {
  const [modal, setModal] = useState<ModalType>(null);
  const { width, height } = useScreenSize();
  {/* @ts-ignore */}
  const isMobile = useMemo(() => (width && width > 780 ? false : true), [width]);
  const isDesktop = useMemo(() => (width && width < 780 ? false : true), [width]);

  useEffect(() => {
    setModal(props.openedModal);
  }, [props.openedModal]);

  const closeModal = () => {
    setModal(null);
  };

  const handleLogin = () => {
    setModal('login');
  }

  return (
    <>
      {modal === "login" && (
        <Modal contentPosition="center" onClose={closeModal}>
          <LoginForm
            variantLabel="login"
            onClose={closeModal}
            onSwitchModal={(modal: ModalType) => setModal(modal)}
            onAfterLogin={props.onAfterLogin}
          />
        </Modal>
      )}

      {modal === "signup" && (
        <Modal contentPosition="center" onClose={closeModal}>
          <SignUpForm
            variantLabel="signup"
            onClose={closeModal}
            onSwitchModal={(modal: ModalType) => setModal(modal)}
            onAfterLogin={props.onAfterLogin}
          />
        </Modal>
      )}

      {modal === "forgot" && (
        <Modal contentPosition="center" onClose={closeModal}>
          <ForgotPasswordForm
            onClose={closeModal}
            onSwitchModal={(modal: ModalType) => setModal(modal)}
          />
        </Modal>
      )}

      <MobileNav
        isLoggedIn={props.isLoggedIn}
        cartItemsAmount={props.cartItemsAmount}
        wishlistItemsAmount={props.wishlistItemsAmount}
        openedModal={props.openedModal}
        isMobile={isMobile}
        onLogout={props.onLogout}
        openModal={props.openModal}
        handleLogin={handleLogin}
        hidden={!isDesktop || isMobile} />

      <DesktopNav
        isLoggedIn={props.isLoggedIn}
        cartItemsAmount={props.cartItemsAmount}
        wishlistItemsAmount={props.wishlistItemsAmount}
        openedModal={props.openedModal}
        isMobile={isMobile}
        onLogout={props.onLogout}
        openModal={props.openModal}
        handleLogin={handleLogin}
        hidden={isDesktop || !isMobile}/>

    </>
  );
};

export default Nav;
